"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GA4SampleOrderTracker = void 0;
var GA4Tracker_1 = require("./GA4Tracker");
var GA4SampleOrderTracker = /** @class */ (function () {
    function GA4SampleOrderTracker() {
    }
    GA4SampleOrderTracker.trackSampleOrderCTA = function (data) {
        var eventOptions = {
            event: 'custom_event',
            event_name: 'order_sample_cta',
            order_sample_cta: data,
        };
        GA4Tracker_1.GA4Tracker.track(eventOptions);
    };
    return GA4SampleOrderTracker;
}());
exports.GA4SampleOrderTracker = GA4SampleOrderTracker;
